// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersInstitutionMobile_filters-institution-mobile__Wj-Fe {
  display: flex;
  gap: 8px;
  align-items: center;
}
.FiltersInstitutionMobile_filters-institution-mobile__Wj-Fe .FiltersInstitutionMobile_filter-trigger__MTHl1 svg {
  border: 1px solid var(--secondary-color);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 5px;
}
.FiltersInstitutionMobile_filters-institution-mobile__Wj-Fe .FiltersInstitutionMobile_filter-trigger__MTHl1 svg path {
  stroke: var(--secondary-color);
  stroke-width: 1px;
}

.ant-drawer-footer .FiltersInstitutionMobile_filters-footer__tujA3 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.ant-drawer-footer .FiltersInstitutionMobile_filters-footer__tujA3 .FiltersInstitutionMobile_apply-button__YExYL {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: black;
  color: white;
  cursor: pointer;
}
.ant-drawer-footer .FiltersInstitutionMobile_filters-footer__tujA3 .FiltersInstitutionMobile_clear-button__c7Et0 {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
}

.ant-drawer-body .FiltersInstitutionMobile_title-filter__WBBPN {
  color: var(--public-profile-color);
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersInstitutionMobile_title-sub-filter__tEji1 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersInstitutionMobile_title-sub-filter-affiliation__6RN6v {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersInstitutionMobile_search-sub-filter__HEhbB {
  margin-top: 5px;
}
.ant-drawer-body .FiltersInstitutionMobile_position__GwQf6 {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersInstitutionMobile_seniority__OBbZZ {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersInstitutionMobile_sub-filter__ty5YR {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionList/Components/FiltersInstitutionMobile/FiltersInstitutionMobile.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;AACI;EACE,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACN;AAAM;EACE,8BAAA;EACA,iBAAA;AAER;;AAKE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AADN;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AADN;;AAME;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ","sourcesContent":[".filters-institution-mobile {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  .filter-trigger {\n    svg {\n      border: 1px solid var(--secondary-color);\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      padding: 5px;\n      path {\n        stroke: var(--secondary-color);\n        stroke-width: 1px;\n      }\n    }\n  }\n}\n\n:global(.ant-drawer-footer) {\n  .filters-footer {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    .apply-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      background: black;\n      color: white;\n      cursor: pointer;\n    }\n    .clear-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      cursor: pointer;\n      margin-right: 10px;\n    }\n  }\n}\n:global(.ant-drawer-body) {\n  .title-filter {\n    color: var(--public-profile-color);\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter-affiliation {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .search-sub-filter {\n    margin-top: 5px;\n  }\n  .position {\n    margin-bottom: 15px;\n  }\n  .seniority {\n    margin-bottom: 15px;\n  }\n  .sub-filter {\n    margin-bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-institution-mobile": `FiltersInstitutionMobile_filters-institution-mobile__Wj-Fe`,
	"filter-trigger": `FiltersInstitutionMobile_filter-trigger__MTHl1`,
	"filters-footer": `FiltersInstitutionMobile_filters-footer__tujA3`,
	"apply-button": `FiltersInstitutionMobile_apply-button__YExYL`,
	"clear-button": `FiltersInstitutionMobile_clear-button__c7Et0`,
	"title-filter": `FiltersInstitutionMobile_title-filter__WBBPN`,
	"title-sub-filter": `FiltersInstitutionMobile_title-sub-filter__tEji1`,
	"title-sub-filter-affiliation": `FiltersInstitutionMobile_title-sub-filter-affiliation__6RN6v`,
	"search-sub-filter": `FiltersInstitutionMobile_search-sub-filter__HEhbB`,
	"position": `FiltersInstitutionMobile_position__GwQf6`,
	"seniority": `FiltersInstitutionMobile_seniority__OBbZZ`,
	"sub-filter": `FiltersInstitutionMobile_sub-filter__ty5YR`
};
export default ___CSS_LOADER_EXPORT___;
